import { combineReducers } from 'redux';
import { keyBy } from 'lodash';

import {
  fetchSurveyQuestionsTypes,
  addSurveyQuestionTypes,
  updateSQuestionTypes,
  addSQuestionOptionTypes,
  removeSQuestionOptionTypes,
  removeSQuestionTypes,
} from './action_types';

import { makeRequestReducer } from '../../config/client';

const main = makeRequestReducer({
  types: fetchSurveyQuestionsTypes,
  name: 'surveyQuestions',
  mutate: (state, res) => ({
    order: (res || []).map(r => r._id),
    keyed: keyBy(res, '_id'),
  }),
});

export default combineReducers({
  main,
});



// WEBPACK FOOTER //
// ./src/modules/survey/reducers.js